import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/auth/Login.vue';
import Register from './views/auth/Register.vue';
import Password from './views/auth/Password.vue';
import ResetPassword from './views/auth/ResetPassword.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/password',
      name: 'password',
      component: Password
    },
    {
      path: '/password/:token',
      name: 'resetpassword',
      component: ResetPassword
    },
    {
      path: '/calls',
      name: 'calls',
      component: () => import(/* webpackChunkName: "calls" */ './views/viewer/Calls.vue')
    },
    {
      path: '/calls/:id',
      name: 'callpage',
      component: () => import(/* webpackChunkName: "calls" */ './views/viewer/CallPage.vue')
    },
    {
      path: '/messages',
      name: 'messages',
      component: () => import(/* webpackChunkName: "messages" */ './views/viewer/MessageList.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "messages" */ './views/Contact.vue')
    },
    {
      path: '/messages/:id',
      name: 'messagepage',
      component: () => import(/* webpackChunkName: "messages" */ './views/viewer/MessagePage.vue')
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: () => import(/* webpackChunkName: "gallery" */ './views/viewer/Gallery.vue')
    },
    {
      path: '/videos',
      name: 'videos',
      component: () => import(/* webpackChunkName: "videos" */ './views/viewer/Videos.vue')
    },
    {
      path: '/videos/:id',
      name: 'videopage',
      component: () => import(/* webpackChunkName: "calls" */ './views/viewer/VideoPage.vue')
    },
    {
      path: '/user/:id',
      name: 'user',
      component: () => import(/* webpackChunkName: "recipients" */ './views/viewer/User.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue')
    },
    {
      path: '/upgrade',
      name: 'upgrade',
      component: () => import(/* webpackChunkName: "upgrade" */ './views/Upgrade.vue')
    },
    {
      path: '/allmessages',
      name: 'allmessages',
      component: () => import(/* webpackChunkName: "creator-messages" */ './views/creator/Messages.vue')
    },
    {
      path: '/allmessages/:id',
      name: 'editmessage',
      component: () => import(/* webpackChunkName: "edit-message" */ './views/creator/EditMessage.vue')
    },
    {
      path: '/send',
      name: 'send',
      component: () => import(/* webpackChunkName: "send-message" */ './views/creator/SendMessage.vue')
    },
    {
      path: '/recipients',
      name: 'recipients',
      component: () => import(/* webpackChunkName: "recipients" */ './views/creator/Recipients.vue')
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import(/* webpackChunkName: "recipients" */ './views/Policy.vue')
    }
  ]
})
